import { cloneRgObject, RG_TYPE, GetAllBones } from "@project-rouge/rg-core";
import { getRgObjectsOfType } from "@project-rouge/rg-three";
import { Vector3 } from "three";
import { rebuildFromSkeleton } from "./index43.js";
const start = new Vector3();
const end = new Vector3();
const center = new Vector3();
const targetCenter = new Vector3();
function changeBoneFloors({
  obj,
  floors,
  buildingId,
  boneId,
  aggProps,
  boneCenter
}) {
  obj = cloneRgObject(obj);
  const { bone, building } = getBuildingAndBone({ obj, buildingId, boneId, boneCenter });
  const prevFloors = bone.floors;
  bone.floors = floors;
  const output = rebuildFromSkeleton({ obj, aggProps, buildingIds: [building.uuid] });
  boneCenter = boneCenter || getBoneCenter(bone).toArray();
  const action = {
    redo: { buildingId, boneId, boneCenter, type: "ChangeBoneFloors", floors },
    undo: { buildingId, boneId, boneCenter, type: "ChangeBoneFloors", floors: prevFloors }
  };
  return { output, action };
}
function getBuildingAndBone({ obj, buildingId, boneId, boneCenter }) {
  let boneAndBuilding;
  if (!boneCenter) {
    boneAndBuilding = getFromIDs({ obj, buildingId, boneId });
  } else {
    boneAndBuilding = getFromIDs({ obj, buildingId, boneId }) || getFromBonePose({ obj, boneCenter });
  }
  if (!boneAndBuilding)
    throw new Error("can't find bone to alter");
  return boneAndBuilding;
}
function getFromIDs({ obj, buildingId, boneId }) {
  const building = getRgObjectsOfType(obj, RG_TYPE.Building).find((b) => b.uuid === buildingId);
  if (!building)
    return;
  const bone = GetAllBones(building.data.anatomy).find((b) => b.id === boneId);
  if (!bone)
    return;
  return { bone, building };
}
function getFromBonePose({ obj, boneCenter }) {
  targetCenter.fromArray(boneCenter);
  const buildings = getRgObjectsOfType(obj, RG_TYPE.Building);
  for (const building of buildings) {
    const bones = GetAllBones(building.data.anatomy);
    for (const bone of bones) {
      if (getBoneCenter(bone).equals(targetCenter))
        return { bone, building };
    }
  }
}
function getBoneCenter(bone) {
  start.fromArray(bone.joints[0].pos);
  end.fromArray(bone.joints[1].pos);
  center.addVectors(start, end).multiplyScalar(0.5);
  return center;
}
export {
  changeBoneFloors
};
//# sourceMappingURL=index34.js.map
